import { useFetchOrganizations } from './useFetchOrganizations'

export const useOrganizations = () => {
  const { organizations, isLoading } = useFetchOrganizations()

  return { organizations, isLoading }
}
